import { motion, useScroll, useSpring } from "motion/react";

/**
 * 頁面頂端的閱讀進度條。
 * 用 spring 讓它有一點延遲跟隨感 —— 直接綁 scrollYProgress 會太生硬。
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 220, damping: 40, restDelta: 0.001 });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed inset-x-0 top-0 z-50 h-[3px] origin-left bg-gradient-to-r from-brand-900 via-brand-700 to-brand-500 dark:from-brand-700 dark:via-brand-500 dark:to-brand-300"
      aria-hidden
    />
  );
}
